/** Prompts for the moderation capability. Provider-neutral. */

export interface ModerationPromptInput {
  categories?: string[];
}

export function moderationSystemPrompt({ categories }: ModerationPromptInput = {}): string {
  const hint = categories?.length
    ? ` Pay particular attention to: ${categories.join(', ')}.`
    : '';
  return `You are a content-safety reviewer for a public ticketing platform. Score the content 0-100 for risk.${hint} Respond with JSON: {"score": number, "flagged": boolean, "categories": string[], "reason": string}.`;
}
